(ns frontend.test.kanban-v2.events
  (:require
   [re-frame.core :as rf]))

(defn mock-n-items
  [n]
  (->> (range n)
       (map (fn [i]
              {:id          i
               :key         i
               :group       (mod i 8)
               :header      (str "Task-" i)
               :owner       (if (= (mod i 2) 0) "Tuukka" "Another one")
               :target      (condp = (mod i 3)
                              0 "Company 1"
                              1 "Company 2"
                              2 "Company 3")
               :country     (condp = (mod i 5)
                              0 "Finland"
                              1 "Sweden"
                              2 "Norway"
                              3 "Denmark"
                              4 "Estonia")
               :description (str "Lorem ipsum dolor sit amet, consectetur adipiscing elit. In pulvinar "
                                 "imperdiet suscipit. Suspendisse non bibendum massa. "
                                 " Cras bibendum quam tortor, eget rutrum")
               :tag         (let [tag-number (mod i 10)]
                              (str "TAG-" tag-number))}))))

(rf/reg-event-db
 ::reset-kanban-db
 (fn [db [_ {:keys [itens-n group-by-attribute]}]]
   (println ::reset-kanban-db)
   (assoc
    db
    :kanban/view-settings {:sorting        {:sort-by        :id
                                            :sort-direction :desc ; :asc |:desc
                                           }
                           :grouping       {}
                           :summary-footer {:show-summary? true
                                            :content       [:total-count]}}
    :kanban/card-settings {:look-and-feel    {:card-size :large         ; :compact || :medium || :large
                                              :show-empty-fields? false ; true || false
                                             }
                           :color-coding     {:use-color-coding? true
                                              :attribute         :owner
                                              :operator          :is
                                              ;; TODO: when implementing this Remove hardcoding
                                              :matches           {"Tuukka"      "#def5ff"
                                                                  "Another one" "pink"}}
                           :border-highlight {:usr-for :rotting-entity}
                           :header           {:display-name :name ; :name || :alias
                                             }

                           :card-footer      {:show-footer? true
                                              :content-type :icons ; :avatar ||:tags || :icons
                                              :content      []     ; Todo
                                             }

                           :card-body        {:content
                                              [{:attribute :tag
                                                :ord       1}
                                               {:attribute :description
                                                :ord       2}
                                               {:attribute :country
                                                :ord       3}
                                               {:attribute :owner
                                                :ord       4}]}}
    :kanban/items (mock-n-items itens-n)
    :kanban/group-by-attribute group-by-attribute)))
